import React, {FunctionComponent, useState, useEffect} from "react"
import {RequirementBlockActionPointDTO} from "../api/models"
import ActionRow from "./ActionRow"
import Button from "@murphy-frontend/web-core/components/Button"
import {useCreateCustomerBlockActionPoint} from "../api/mutations"
import {useCustomer} from "../../../common/contexts/CustomerContext"
import {CreateBlockActionPointRequest} from "../api/models"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"
import {useParams} from "react-router-dom"

interface ActionsProps {
	actions: RequirementBlockActionPointDTO[]
	blockId: number
}

const Actions: FunctionComponent<ActionsProps> = ({actions, blockId}) => {
	const [description, setDescription] = useState("")
	const [enableEdit, setEnableEdit] = useState(false)
	const {translations} = useUserPreferences()
	const {customer} = useCustomer()
	let {customerId} = useParams()
	const {mutate: createCustomerActionPoint, isPending: createCustomerActionPointIsLoading} =
		useCreateCustomerBlockActionPoint()

	const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		e.preventDefault()
		setDescription(e.target.value)
	}

	const onCancel = () => {
		setDescription("")
		setEnableEdit(false)
	}

	const onSave = () => {
		let cId = customerId
		if (!cId) cId = customer.Id
		const submitUpdateBlock = () => {
			const request: CreateBlockActionPointRequest = {
				CustomerId: cId,
				Description: description,
				RequirementBlockId: blockId
			}
			createCustomerActionPoint(request, {
				onSettled: () => {
					console.log("done")
					setEnableEdit(false)
				},
				onError: () => {
					setEnableEdit(false)
				}
			})
		}
		submitUpdateBlock()
	}

	return (
		<div className='actions-container'>
			<div className='actions-row-wrapper'>
				{actions.map(act => (
					<ActionRow action={act} key={act.RequirementBlockActionPointId} />
				))}
			</div>
			{enableEdit && (
				<div className='actions-edit-wrapper'>
					<textarea
						className='actions-row-textarea'
						value={description}
						disabled={false}
						onChange={handleDescriptionChange}
						placeholder={(translations.addActionPoint || "Add action point") + "..."}
						rows={1}
					/>
					<div className='actions-row-edit-btn'>
						<Button
							onClick={onSave}
							buttonSize={"btn--medium"}
							isNeutralButton={true}
							isLoading={createCustomerActionPointIsLoading}
						>
							{translations.save || "Save"}
						</Button>
						<Button onClick={onCancel} buttonSize={"btn--medium"} isLightButton={true}>
							{translations.cancel || "Cancel"}
						</Button>
					</div>
				</div>
			)}
			<div className='actions-btn-container'>
				<Button
					buttonSize={"btn--medium"}
					buttonStyle={"btn--add"}
					reverseFlow={true}
					customClasses={"actions-icon-btn"}
					onClick={() => setEnableEdit(true)}
				>
					{translations.addActionPoint || "Add action point"}
				</Button>
			</div>
		</div>
	)
}

export default Actions
